import { columnHelper } from './helper';

/**
 * Report age as the API server rendered it. The exact scan timestamp
 * (report.updateTimestamp) is not a printer column, and fetching it would mean
 * pulling every finding for every row.
 */
export const age = columnHelper.accessor('age', {
  header: 'Report age',
  id: 'age',
  cell: ({ getValue }) => getValue() ?? '-',
});
